import styled from '@emotion/styled';
import { Magnetic } from '@mitchell/react.component.ux';
export const StyledDivAdditionalPhotosContainer = styled('div') `
	padding-bottom: ${Magnetic.spacer24};
	margin: ${Magnetic.spacer12} 0 ${Magnetic.spacer24} 0;
	position: relative;
`;
//# sourceMappingURL=AdditionalPhotosComponent.style.js.map